export function isTruthy(value) {
    return value === true
        || value === 'true'
        || value === '1'
        || value === 1;
}

export function isFalsey(value) {
    return !isTruthy(value);
}
